<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="861px" class="dialog" :show-close="false">
      <div v-loading="loading">
        <div class="header">
          <div class="header_title">
            <img :src="require('@/assets/icon/address_map.png')" alt="">
            <div class="header_title_text"><span>我的地址簿</span></div>
          </div>
          <div class="header_close" @click="close"><img :src="require('@/assets/icon/address_close.png')" alt=""></div>
        </div>
        <div class="content">
          <div class="search">
            <div class="search_left">
              <el-input v-model.trim="searchWord" placeholder="输入姓名、电话进行查询" maxlength="100" clearable></el-input>
            </div>
            <div class="search_right" @click="query">
              <img :src="require('@/assets/icon/address_search.png')" alt="">
              <span>查询</span>
            </div>
          </div>
          <div class="list">
            <div class="item" :class="selectIndex == index ? 'item_active' : ''" @click.stop="addressChange(item,index)" v-for="(item, index) in list" :key="index">
              <div class="item_name">{{item.name}}</div>
              <div class="item_phone">{{item.mobilePhone}}</div>
              <div class="item_address">{{item.provinceSpan}}-{{item.citySpan}}-{{item.countySpan}}-{{item.address}}</div>
            </div>
          </div>
          <!-- <div class="pagination">
            <el-pagination background layout="prev, pager, next" :total="total">
            </el-pagination>
          </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addressList } from "@/api/home";
export default {
  name: 'UserAddress',
  data() {
    return {
      dialogVisible: false,
      searchValue: '',
      selectAddressId: null,
      selectAddress: {},
      total:20,
      loading:false,
      list:[],
      selectIndex:undefined,
      searchWord:'',
      dataType:1
    }
  },

  methods: {
    open() {
      this.dialogVisible = true;
      this.getAddressList();
    },
    close() {
      this.dialogVisible = false;
    },
    // 获取地址簿
    async getAddressList(){
      this.loading = true;
      addressList({searchWord:this.searchWord,dataType:this.dataType}).then(response => {
        console.log(response);
        this.list = response.data;
        this.loading = false;
      })
    },
    addressChange(val,index){
      this.selectIndex = index;
      this.selectAddress = val;
      this.$emit('change',val);
      this.close();
    },
    query(){
      this.getAddressList();
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 !important;
}

::v-deep .el-dialog__header {
  padding: 0 !important;
}

::v-deep .el-dialog {
  max-height: 530px;
  overflow-y: auto;
}

.header {
  width: 100%;
  height: 83px;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 21px;

  .header_title {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 33px;
    border-bottom: 1px solid rgba($color: #979797, $alpha: 0.21);

    img {
      width: 24px;
      height: 24px;
      margin-right: 13px;
    }

    .header_title_text {
      font-size: 24px;
      font-weight: 500;
      color: #333;
    }
  }

  .header_close {
    width: 39px;
    height: 39px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1000;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.content {
  box-sizing: border-box;
  padding: 0 33px;
  padding-bottom: 30px;
}

.search {
  width: 389px;
  height: 42px;
  display: flex;
  align-items: center;

  margin-bottom: 30px;

  .search_left {
    width: 312px;
    height: 42px;
    border-radius: 4px 0px 0px 4px;
    box-sizing: border-box;
    border: 1px solid rgba($color: #979797, $alpha: 0.43);
    border-right: 0;

    ::v-deep .el-input__inner {
      border-color: transparent !important;
      background: transparent !important;
      font-size: 14px;
      color: #333;
    }
  }

  .search_right {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 77px;
    box-sizing: border-box;
    height: 42px;
    background: #FF8A00;
    border-radius: 0px 4px 4px 0px;
    background: #FF8A00;
    color: #fff;
    font-size: 14px;
    cursor: pointer;

    img {
      width: 15px;
      height: 16px;
      margin-right: 5px;
    }
  }

}

.list {
  .item {
    width: 100%;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba($color: #d8d8d8, $alpha: 0.26);
    box-sizing: border-box;
    padding: 0 20px;
    cursor: pointer;
    margin-bottom: 12px;

    .item_name {
      width: 100px;
      margin-right: 10px;
    }

    .item_phone {
      width: 140px;
      margin-right: 10px;
    }

    .item_address {
      flex: 0.95;
    }
  }
  .item_active{
    background: rgba($color: #FF8A00, $alpha: 0.1);
  }
}
.pagination{
  padding-top: 20px;
  display: flex;
  justify-content: center;
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color:#FF8A00 !important;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #FF8A00 !important;
  }
}
</style>